import * as $ from "jquery";
import SearchResult from "AWFWSK/Grids/Configs/SearchResult";
import FilterGrid from "AWFGrid/Grids/FilterGrid";
import * as i18n from 'CMS/core/i18n';
import * as searchSuggestDatasource from 'AWFWSK/Data/Datasources/SearchSuggestDatasource';
import 'kendo/kendo.autocomplete';

export default class MenuPart {
    private $root: JQuery<HTMLElement>;
    private searchActive: boolean = false;
    private $searchInput: JQuery<HTMLElement>;
    private $searchCriteria: JQuery<HTMLElement>;
    private $mainMenuContainer: JQuery<HTMLElement>;
    private $searchToggle: JQuery<HTMLElement>;
    private $searchButton: JQuery<HTMLElement>;
    private $clearSearch: JQuery<HTMLElement>;
    private $searchContainer: JQuery<HTMLElement>;
    private $navigationContainer: JQuery<HTMLElement>;
    private $inputContainer: JQuery<HTMLElement>;

    constructor() {
    }

    public initialize(options: any) {
        this.$root = $(options.root);

        // Internationalisation
        i18n.bind(this.$root);

        /* prevent close of megamenu on click */
        this.$root.on('click', '.dropdown.open .megamenu', (e) => { e.stopPropagation(); });

        this.$root.find('.navbar-collapse').on('show.bs.collapse', () => {
            $('body').addClass('menu-open');
        });
        this.$root.find('.navbar-collapse').on('hidden.bs.collapse', () => {
            $('body').removeClass('menu-open');
        });

        // Search button
        this.$mainMenuContainer = this.$root.find('.main-menu-container');
        this.$searchToggle = this.$mainMenuContainer.find('#searchToggle');
        this.$searchButton = this.$mainMenuContainer.find('#search');
        this.$clearSearch = this.$mainMenuContainer.find('#clearSearch');
        this.$navigationContainer = this.$mainMenuContainer.find('.navigation-container');
        this.$searchContainer = this.$mainMenuContainer.find('.search-container');
        this.$searchInput = this.$searchContainer.find('#searchInput');
        this.$searchCriteria = this.$searchContainer.find('.search-criteria');
        this.$inputContainer = this.$searchContainer.find('.input-container');
        this.$inputContainer.width("100%");

        this.$root.on('click', '.main-menu-container .dropdown-menu', e => {
            e.stopPropagation();
        });

        this.$searchToggle.click(e => {
            e.preventDefault();

            if (!this.searchActive) {
                this.$navigationContainer.toggleClass('hidden', true);
                this.$searchContainer.toggleClass('hidden', false);
                this.$searchContainer.animate({
                    width: '100%'
                });

                this.$searchInput.val('');
                this.$searchInput.focus();
                this.$mainMenuContainer.css('padding-left', 0);
                this.$mainMenuContainer.css('padding-right', 0);
                this.searchActive = true;
            }
        });

        this.$clearSearch.click((e) => this.clearSearch(e));

        this.$searchButton.click(async (e) => await this.searchClickHandler(e));

        /* Suggest autocomplete */
        this.$searchInput.kendoAutoComplete({
            noDataTemplate: null,
            clearButton: false,
            dataTextField: 'suggestion',
            template: '#:suggestion#',
            select: async (e) => {
                if (e.dataItem && e.dataItem.suggestion) {
                    this.$searchInput.val(e.dataItem.suggestion);
                    this.$searchButton.trigger('click');
                }
            },
            dataSource: searchSuggestDatasource.create()
        });

        // set the search width to the autocomplete elements
        const width = this.$mainMenuContainer.width() - this.$searchButton.outerWidth() - this.$clearSearch.outerWidth() - 10;
        this.$inputContainer.find('span').width(width);
        this.$inputContainer.find('input').css('padding-bottom', 5);
        this.$inputContainer.find('input').css('padding-left', 0);
        this.$searchInput.data("kendoAutoComplete").list.width(width);

        this.$searchInput.keyup(e => {
            if (e.which === 13) {
                this.$searchButton.trigger('click');
            }
        });
    }

    public destroy() {
    }

    private clearSearch(e: JQuery.ClickEvent) {
        e.preventDefault();

        this.$root.find('.Grid').empty();
        this.$root.find('div.search-button-container').removeClass('open');

        if (this.searchActive) {
            this.$navigationContainer.toggleClass('hidden', false);
            this.$searchContainer.width(0);
            this.$searchContainer.toggleClass('hidden', true);
            this.$mainMenuContainer.css('padding-left', 15);
            this.$mainMenuContainer.css('padding-right', 15);
            this.searchActive = false;
        }
    }

    private async searchClickHandler(e: JQuery.ClickEvent) {
        e.preventDefault();

        if (this.searchActive) {
            let searchInput = <string>this.$searchInput.val();

            $(e.target).parent().addClass('open');

            // Search
            await this.initializeSearchGrid(this.$root, searchInput);

            // Search input html
            this.$searchCriteria.empty();
            this.$searchCriteria.html(searchInput);
        }
    }

    public async initializeSearchGrid($root: JQuery<HTMLElement>, criteria: string) {
        let $grid = $root.find('.Grid');

        $grid.empty();

        let grid = new FilterGrid(true, false);

        await grid.initialize($grid, {
            filterType: 'menupartsearch',
            gridType: new SearchResult(criteria),
            listViewOnly: true,
            pageSize: 10,
            click: (dataItem: any) => {
                window.location.href = dataItem.detailsPage;
            }
        });
    }
}